export enum ConfirmationFlow {
  ConfirmationFlow_Account = 'ConfirmationFlow_Account',
  ConfirmationFlow_Email = 'ConfirmationFlow_Email'
}
